<template>
  <div id="login-page">
    <md-empty-state md-icon="vpn_key">
      <md-button
        @click="api.session.login(redirect)"
        class="md-raised md-primary"
        >Login</md-button
      >
    </md-empty-state>
    <md-layout
      md-align="center"
      md-justify="center"
      class="privacy-policy-external"
      v-if="privacyPolicyExist"
    >
      <md-layout-item
        md-align="center"
        md-justify="center"
        class="privacy-policy-internal"
        @click="viewPrivacyPolicy()"
        ><span>개인정보 처리방침</span></md-layout-item
      >
    </md-layout>
  </div>
</template>
<script>
import api from '@/api'
import config from '@/config'

export default {
  data: () => ({
    redirect: null,
    platform: ['gcp', 'alibaba'],
  }),

  props: {
    invoiceSeq: String,
  },

  computed: {
    privacyPolicyExist() {
      return this.platform.includes(config.platform.id)
    },
  },

  mounted() {
    const redirect = window.$cookies.get('__redirect')
    if (redirect && redirect.trim() !== '') {
      this.redirect = redirect.trim()
    } else {
      this.redirect = document.location.origin
    }
    window.$cookies.remove('__redirect')
  },

  methods: {
    viewPrivacyPolicy() {
      api.download.privacyPolicy()
    },
  },
}
</script>
<style scoped>
#login-page {
  display: flex;
  height: 80vh;
}

.privacy-policy-external {
  bottom: 0;
  width: 100%;
  position: absolute;
  text-align: center;
  margin-bottom: 10px;
}

.privacy-policy-internal {
  cursor: pointer;
  color: #707479;
  text-decoration: underline;
}
</style>
